import { Observable } from 'rxjs';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { TagService } from '@brafton/atlas-api-client';
import { Tag } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-filter-panel-tags',
  templateUrl: './filter-panel-tags.component.html',
  styleUrls: ['./filter-panel-tags.component.scss'],
  host: { class: 'filter-panel-tags' },
})
export class SharedFilterPanelTagComponent implements OnInit {
  @Input() feedId?: number;
  @Input() parentTagId = 'b37a39b2';
  @Input() tags: Filter[] = [];

  @Output() tagsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  tags$!: Observable<Tag[]>;
  allTags!: Tag[];

  constructor(private tagsService: TagService) {}

  ngOnInit() {
    this.tags$ = this.tagsService.listTags(this.parentTagId, this.feedId);
  }

  add(tagDef: Tag) {
    if (!this.tags.find((sp) => sp.value === tagDef.tagId)) {
      this.tags.push({ value: tagDef.tagId, displayName: tagDef.name, type: 'tag' } as Filter);
    }
    this.tagsChange.emit(this.tags);
  }

  remove(tagDef: Tag) {
    const index = this.tags.findIndex((sp) => sp.value === tagDef.tagId);
    if (index > -1) {
      this.tags.splice(index, 1);
    }
    this.tagsChange.emit(this.tags);
  }

  clear() {
    this.tags = [];
    this.tagsChange.emit(this.tags);
  }

  isSelected(tagDef: Tag): boolean {
    if (!this.tags) return false;
    if (this.tags.find((sp) => sp.value === tagDef.tagId)) return true;
    else return false;
  }
}
